import { render, staticRenderFns } from "./VLeadDealInfo.vue?vue&type=template&id=6c5f597a"
import script from "./VLeadDealInfo.vue?vue&type=script&lang=js"
export * from "./VLeadDealInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports